import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import global from '@/common/global' 
import store from './store'
import VueClipboard from 'vue-clipboard2'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// 引入全局样式文件
import '@/assets/less/index.less'
import moment from 'moment'
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.prototype.GLOBAL = global
Vue.use(ElementUI)
Vue.use(VueClipboard)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
